import { atom } from 'recoil'

export const $idTaggingEnabled = atom<boolean>({
  key: 'idTaggingEnabled',
  default: false,
})
